<script>
    import { onMount } from "svelte";
    export let data = null
    export let labels = null
    export let title = null
    export const titleData = null

    onMount(async () => {
        if (data && Canvas) {
            data.forEach(element => {
                ColorR.push(dynamicColors())
            }),
            renderChart()
        }
    });

    let Canvas = null
    let ColorR = []

    var dynamicColors = function() {
        var r = Math.floor(Math.random() * 255);
        var g = Math.floor(Math.random() * 255);
        var b = Math.floor(Math.random() * 255);
        return `rgba(${r},${g},${b},${0.8})`;
    };

    

    function renderChart() {
        var ctx = Canvas.getContext("2d");
        var chart = new Chart(ctx, {
            type: "doughnut",
            data : {
                labels: labels,
                datasets: [{
                    label: title,
                    data: data,
                    backgroundColor: ColorR,
                    hoverOffset: 1
                }]
            },
            options: { 
                maintainAspectRatio: false ,
                plugins: {
                    title: {
                        display: true,
                        text: title,
                        padding: {
                            top: 10,
                            bottom: 30
                        }
                    },
                    legend: {
                        display: true,
                        labels: {
                            color: 'rgb(255, 99, 132)'
                        },
                        position: 'bottom',
                        titleData
                    }
                }
            }
        });
    }
</script>

<div class="chart-container">
    <canvas bind:this={Canvas} style="padding: 20px;" />
</div>

<style>
    .chart-container {
        position: relative;
        margin: auto;
        height: 40vh;
        width: 40vh;
    }
</style>
